import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { ElevatedButton } from '@producer/ui-kit';

import { Header } from './project.page';
import { useCurrentProject } from '../../hooks/use-current-project';
import { CharacterCards } from '../../features/character/components/character-cards';
import { CreateCharacterDrawer } from '../../features/character/components/create-character.drawer';
import { uiStore } from '../../core/stores/ui-store';
import { CharacterListPlaceholder } from '../../features/character/components/character-list-placeholder';

import styles from './project-characters.route.module.scss';
export const ProjectCharactersRoute = observer(() => {
  const project = useCurrentProject()!;
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  useEffect(() => {
    uiStore.currentLocation = 'project.characters';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  return (
    <>
      <Header>
        <div>Characters</div>
        <ElevatedButton text="Create character" onClick={() => setIsCreateModalOpen(true)} />
      </Header>

      <div className={styles['content']}>
        <div className={styles['container']}>
          {project.characters.length !== 0 ? (
            <CharacterCards characters={project.characters} />
          ) : (
            <CharacterListPlaceholder onAddCharacterClicked={() => setIsCreateModalOpen(true)} />
          )}
        </div>

        {isCreateModalOpen && (
          <CreateCharacterDrawer
            projectId={project._id}
            onCancel={() => setIsCreateModalOpen(false)}
          />
        )}
      </div>
    </>
  );
});
